import { render, staticRenderFns } from "./PermissionsSelector.vue?vue&type=template&id=10c7f712&"
import script from "./PermissionsSelector.vue?vue&type=script&lang=js&"
export * from "./PermissionsSelector.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
